import { PairChallenge } from '@era/locations-sdk';
import { ErrorModel } from '@era/app';

export interface State {
  code: string;
  pairChallenge: PairChallenge;
  isVerifyingCode: boolean;
  isEnrolling: boolean;
  isCodeValid: boolean;
  isCodeValidated: boolean;
  isEnrollmentCompleted: boolean;
  error: ErrorModel;
}

export const initialState: State = {
  code: undefined,
  pairChallenge: undefined,
  isVerifyingCode: false,
  isCodeValid: false,
  isCodeValidated: false,
  isEnrolling: false,
  isEnrollmentCompleted: false,
  error: undefined,
};
